import { c as _c } from "react/compiler-runtime";
import { AvatarPlaceholder } from '@/features/payload-cms/components/accordion/avatar-placeholder';
import type { Image as ImageType } from '@/features/payload-cms/payload-types';
import { cn } from '@/utils/tailwindcss-override';
import Image from 'next/image';
import type React from 'react';
export const TeamLeaderPortrait: React.FC<{
  name: string;
  portrait: string | ImageType | null | undefined;
  hoverEffect: boolean;
}> = t0 => {
  const $ = _c(8);
  const {
    name,
    portrait,
    hoverEffect
  } = t0;
  if (portrait === null || portrait === undefined) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <AvatarPlaceholder />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const portraitSource = typeof portrait === "string" ? portrait : portrait.sizes?.large?.url ?? "";
  if (portraitSource === "") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <AvatarPlaceholder />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = `Portrait of ${name}`;
  const t2 = hoverEffect && "group-hover:scale-105";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("h-full object-cover transition-transform", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== portraitSource || $[5] !== t1 || $[6] !== t3) {
    t4 = <Image src={portraitSource} alt={t1} width={200} height={200} className={t3} />;
    $[4] = portraitSource;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};